import { useCallback, useLayoutEffect, useRef } from 'react';

/*
 * This hook has a unique use case, its used to safely pass a callback received as props/params
 * on a component/hook to pass inside a useEffect/useLayoutEffect without the need to memoizing the function
 * from outside.
 *
 * Example:
 * function Component(props) {
 *
 *  cosnt onClick = useEffectCallback(props.onClick);
 *
 *  useEffect(() => { onClick() }, []);
 *
 * return <div/>
 * }
 */
export default function useEffectCallback(callback?: (...args: any) => any) {
  const ref = useRef(callback);

  useLayoutEffect(() => {
    ref.current = callback;
  });

  return useCallback((...args: any) => {
    if (ref.current) {
      return ref.current(...args);
    }
  }, []);
}
